import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/notifications';
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchaseNotifications.length);
        setIsVisible(true);
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = purchaseNotifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-202" data-mp="otldn1k2ww9g">
      <AnimatePresence mode="wait" data-id="element-203" data-mp="jv1nsq2d70bt">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-dark-card border border-gold/30 rounded-xl p-3.5 shadow-[0_4px_30px_rgba(212,175,55,0.25)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-204" data-mp="evxe7ybj30ky">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors duration-150 ease-out" aria-label="Chiudi le notifiche di acquisto" data-id="element-205" data-mp="ylr0jwvh4nhs">
              <XIcon size={14} aria-hidden="true" data-id="element-206" data-mp="3koybfjo451so" />
            </button>

            <div className="flex items-center gap-3" data-id="element-207" data-mp="3ppdoea4hg7a4">
              <div className="relative shrink-0" data-id="element-208" data-mp="3at4qpd08q1zt">
                <span className="w-11 h-11 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-sm" data-id="element-209" data-mp="3asd6eyc3fqou">
                  {current.initials}
                </span>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Bandiera ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-dark-card" data-id="element-210" data-mp="31z04j6w1xeqm" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-211" data-mp="2wz3zr5fj5ja0">
                <p className="flex items-center gap-1.5 text-[11px] text-gray-400 mb-0.5" data-id="element-212" data-mp="2j172e6t958ua">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover shrink-0" data-id="element-213" data-mp="2n3k9ayjqjcsn" />
                  <span className="truncate" data-id="element-214" data-mp="1zgovx9pvhxmk">{current.location}</span>
                </p>

                <p className="text-white text-[13px] leading-snug" data-id="element-215" data-mp="2dfokyihasej9">
                  <span className="font-bold" data-id="element-216" data-mp="28gbt1jbkkh9t">{current.name}</span>{' '}
                  <span className="text-gray-300" data-id="element-217" data-mp="28ig2shw5gai0">
                    ha acquistato Metodologia della Ricerca Pro
                  </span>
                </p>

                <p className="flex items-center gap-1.5 text-[10px] text-gold-light font-medium mt-1" data-id="element-218" data-mp="2idgflk9buer5">
                  <ShoppingBagIcon size={10} aria-hidden="true" data-id="element-219" data-mp="2w4v0xxqpis1d" />
                  <span data-id="element-220" data-mp="2s4ku6iv3bxlg">Acquisto verificato • {current.time}</span>
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}